// Quem aparece na aba Efetivo do "Enviar para o Financeiro" (Rafael, 06/10).
//
// Só entra no Efetivo o plano que o Financeiro APROVOU. Reprovado fica na Previsão
// de Pagamento para ser editado e reenviado; enviado/rascunho ainda aguardam.
// Exceção: plano que voltou para "enviado" (edição depois da aprovação) mas já tem
// parcela liberada para Contas Pendentes — essa já andou e segue no Efetivo.
// Camada 2: 422 da API em salvarParcelasEfetivo.
//
// Aprovado SEM fornecedor (card "(Fornecedor a definir)", 06/10): aparece no Efetivo, mas só
// para consulta — nada é editável até o operador escolher o fornecedor na linha do orçamento.

import { ehCardADefinir } from './fornecedorADefinirPolicy';

export const MSG_EFETIVO_SEM_FORNECEDOR = 'Precisa ser definido o fornecedor. Escolha o fornecedor na linha do orçamento: até lá esta linha fica só para consulta no Efetivo e não segue para pagamento.';
// Mesma frase do 422 da API (salvarParcelasEfetivo).
export const MSG_SALVAR_SEM_FORNECEDOR = 'Fornecedor a definir: escolha o fornecedor na linha do orçamento para editar o Efetivo.';

export function efetivoSomenteLeitura(forn) {
    return ehCardADefinir(forn);
}

export function fornecedorNoEfetivo(forn) {
    if (!forn) return false;
    if (forn.status === 'aprovado') return true;
    if (forn.status === 'reprovado') return false;
    return (forn.parcelas_aprovadas || []).some(p => !!p.liberado_financeiro_at);
}

export function algumFornecedorNoEfetivo(fornecedores) {
    return (fornecedores || []).some(fornecedorNoEfetivo);
}
